import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateUpdateBudget = async ({
  communityId,
  budgetId,
  data,
}: {
  communityId: string;
  budgetId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(
    `${BUDGET(communityId)}/${budgetId}`,
    data
  );
};

const useUpdateBudgetMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateBudget,
    ...queryParams,
  });

export default useUpdateBudgetMutation;